import {
  LiveRowMetadata,
  PrimarySample,
  StructuredTableAdapter,
  StructuredTableColumn,
  StructuredTableRow,
  StructuredTableRowUpdater,
} from '../StructuredTableConstants';

/**
 * Return the upstream values that can be stored in a table row's metadata.
 *
 * This function is used for fetching live data to be rendered, without persisting it on the table. This is
 * currently done to render live archive state without persisting it, but can also be used for stale
 * indicators if we ever choose to show staleness for row metadata.
 */
export function getLiveRowMetadataFromRowUpdater<TTableMetadata, TRowMetadata>({
  row,
  primarySamples,
  adapter,
  columns,
}: {
  row: StructuredTableRow<TRowMetadata>;
  primarySamples: Array<PrimarySample>;
  adapter: StructuredTableAdapter<TTableMetadata, TRowMetadata>;
  columns: Array<StructuredTableColumn>;
}): LiveRowMetadata {
  const rowUpdater = adapter.getTableKindRowUpdater();
  if (rowUpdater != null) {
    return getUpdatedRowMetadataFromRowUpdater(primarySamples, rowUpdater, row, columns);
  }
  return {};
}

function getUpdatedRowMetadataFromRowUpdater(
  primarySamples: Array<PrimarySample>,
  rowUpdater: StructuredTableRowUpdater,
  row: StructuredTableRow,
  columns: Array<StructuredTableColumn>
): LiveRowMetadata {
  if (primarySamples.length === 0) {
    return {};
  }
  let updatedRow = row;
  for (const {sampleLookupInfo} of primarySamples) {
    const modelFromCache = sampleLookupInfo != null ? rowUpdater.readFromCache(sampleLookupInfo) : null;
    if (modelFromCache == null) {
      return {};
    }
    updatedRow = rowUpdater.updateRow(modelFromCache, columns, updatedRow, null);
  }
  return {archivePurpose: updatedRow.lastSyncedArchivePurpose};
}
